import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ScrollProgressIndicator } from './components/ScrollProgressIndicator';
import { ChatBot } from './components/ChatBot';
import { CookieBanner } from './components/CookieBanner';
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Projects } from './pages/Projects';
import { LocalLanding, LANDING_PAGE_SLUGS } from './pages/LocalLanding';
import { ProjectDetail } from './pages/ProjectDetail';
import { Strategy } from './pages/Strategy';
import { Contact } from './pages/Contact';
import { Admin } from './pages/Admin';
import { Privacy } from './pages/Privacy';
import { Impressum } from './pages/Impressum';
import { TschauSepp } from './pages/TschauSepp';
import { TschauSeppRunde } from './pages/TschauSeppRunde';
import { Blog } from './pages/Blog';
import { BlogPost } from './pages/BlogPost';
import { PillarPage } from './pages/PillarPage';
import { Sitemap } from './pages/Sitemap';
import { NotFound } from './pages/NotFound';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    // Use both methods for maximum compatibility
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  
  return null;
};

const Layout = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';
  const isTschauSepp = location.pathname === '/tschausepp' || location.pathname.startsWith('/runde/');
  
  // Admin and TschauSepp pages use their own layout
  if (isAdmin || isTschauSepp) {
    return children;
  }
  
  return (
    <>
      <Header />
      {children}
      <Footer />
      <ScrollProgressIndicator />
      <ChatBot />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ueber-uns" element={<About />} />
            <Route path="/projekte" element={<Projects />} />
            <Route path="/projekte/:id" element={<ProjectDetail />} />
            <Route path="/strategie" element={<Strategy />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/datenschutz" element={<Privacy />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/tschausepp" element={<TschauSepp />} />
            <Route path="/runde/:roundId" element={<TschauSeppRunde />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/immobilien-verkauf" element={<PillarPage slug="immobilien-verkauf" />} />
            <Route path="/immobilien-kauf" element={<PillarPage slug="immobilien-kauf" />} />
            <Route path="/renditeobjekt-kaufen" element={<PillarPage slug="renditeobjekt-kaufen" />} />
            <Route path="/renditeobjekt-verkaufen" element={<PillarPage slug="renditeobjekt-verkaufen" />} />
            <Route path="/sitemap" element={<Sitemap />} />
            {LANDING_PAGE_SLUGS.map(slug => (
              <Route key={slug} path={`/${slug}`} element={<LocalLanding />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
